"use client";

import { useContext } from "react";

import { CheckoutContext } from "../components/Checkout.context";

export function useCheckoutContext() {
  const context = useContext(CheckoutContext);

  if (!context) {
    throw new Error("CheckoutContext must be used within a CheckoutProvider");
  }

  return context;
}
